<template>
    <div class="switch-button-box" :class="{ 'switch-button-box--disabled': disabled }">
        <label :for="id" class="switch-button-box--label">
            <span class="switch">
                <input type="checkbox"
                       :id="id"
                       v-model="localValue"
                       :true-value="trueValue"
                       :false-value="falseValue"
                       :disabled="disabled"
                >
                <span class="slider" />
            </span>
            <span>
                <!--@slot Use this slot for checkbox label-->
                <slot>
                    {{ label }}
                </slot>
            </span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        /**
         * Input label, Can be used instead of default slot
         */
        label: {
            type: String,
            default: '',
        },
        /**
         * Input value
         */
        value: {
            type: Boolean,
            default: false,
        },
        /**
         * Checkbox true value
         */
        trueValue: {
            type: [Number, Boolean, String],
            default: true,
        },
        /**
         * Checkbox false value
         */
        falseValue: {
            type: [Number, Boolean, String],
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            id: null,
        };
    },
    computed: {
        /**
         * Input value
         */
        localValue: {
            get () {
                return this.value;
            },
            set (x) {
                if (this.disabled) return;
                this.$emit('input', x);
            },
        },
    },

    mounted () {
        this.id = 'switch-' + this._uid;
    },
};
</script>

<style lang="scss">
    @import '~vars';

    .switch-button-box {
        display: inline-block;

        &--label {
            width: 100%;
            margin: 0;
            @media (max-width: 767px) {
                font-size: 0.9em;
            }
        }

        /* Switch button */

        .switch {
            position: relative;
            display: inline-block;
            width: 31px;
            height: 18px;
            vertical-align: middle;
            cursor: pointer;
        }

        .switch input {
            opacity: 0;
            width: 0;
            height: 0;
        }

        .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: $gray-light;
            -webkit-transition: 0.4s;
            transition: 0.4s;
            border-radius: 34px;
        }

        .slider::before {
            position: absolute;
            content: '';
            height: 12px;
            width: 12px;
            left: 3px;
            top: 50%;
            transform: translate(0, -50%);
            background-color: white;
            -webkit-transition: 0.4s;
            transition: 0.4s;
            border-radius: 50%;
        }

        input:checked + .slider {
            background-color: $blue-primary;
        }

        input:focus + .slider {
            box-shadow: 0 0 1px $blue-primary;
        }

        input:checked + .slider::before {
            transform: translate(12px, -50%);
        }

        &.switch-button-box--disabled {

            .slider {
                cursor: not-allowed;
                opacity: 0.85;
            }
        }
    }
</style>
